import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  FilterDTO,
  PagedResultDTOOfProblemReportLogResponseDTO,
  ProblemReportClient,
  SortDirection,
} from '../../../../base/models/models.swagger.generated';
import { IAdaptorService } from '../../../../base/shared/syncfusion/adaptor-service.interface';

@Injectable()
export class ProblemReportLogsService implements IAdaptorService {

  public problemReportId: number | null = null;
  public additionalFilters: FilterDTO[] = [];

  constructor(private problemReportClient: ProblemReportClient) {}

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfProblemReportLogResponseDTO> {
    if (!this.problemReportId) {
      return of(null);
    }
    if (!sortBy) {
      sortBy = 'Timestamp';
      sortDirection = SortDirection.Ascending;
    }

    const allFilters = [
      ...(filters ?? []),
      ...this.additionalFilters,
    ];

    return this.problemReportClient.searchProblemReportLogs(
      this.problemReportId,
      allFilters.length > 0 ? allFilters : undefined,
      skip,
      take,
      sortBy,
      sortDirection,
    );
  }

  public addRecord(_data: any): Observable<any> {
    return of(null);
  }

  public updateRecord(_data: any): Observable<any> {
    return of(null);
  }

  public deleteRecord(_id: number): Observable<any> {
    return of(null);
  }
}
